import React, { useState } from "react";

function CardboardPickupFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How much does cardboard pickup cost?",
      content: `
Pricing varies based on the amount of cardboard waste. Get an estimate with our instant upfront pricing.
      `,
    },
    {
      title: "Do I need to break down boxes before pickup?",
      content: `
       We prefer flattened cardboard, but we can handle the break down boxes process for you.
      `,
    },
    {
      title: "Do you recycle all collected cardboard?",
      content: `
       Yes! We work with recycle centers to ensure recyclable materials are turned into new products.
      `,
    },
    {
      title: "Can you pick up other junk along with cardboard?",
      content: `
         Absolutely! We offer junk hauling, furniture removal, Scrap Metal collection, and Solid Waste disposal.
        `,
    },
    {
      title: "How do I book a pickup?",
      content: `
         Simply call or message us to schedule a same-day pickup or curbside pickup today!
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default CardboardPickupFAQs;
